import React from "react";
import { isEmpty } from "lodash-es";
import Skeleton from "@material-ui/lab/Skeleton";
import { useSelector } from "react-redux";
import { getAccountStore } from "@/store/account/actions";
import { Box } from "@material-ui/core";
import { Typography } from "@dev/ee-components";
import useMobile from "@/services/hooks/useMobile";
import { useTranslation } from "react-i18next";
import { GridWithPadding, SkeletonWrapperWelcomeMsg } from "./styles";

const welcomeHeader = {
    minHeight: '44px',
    display: 'flex',
    alignItems: 'center',
};

export const Welcome = (): JSX.Element => {
    const { t } = useTranslation();
    const { Profile, accountLoading, warnings } = useSelector(getAccountStore);
    const isMobile = useMobile(); 
    const profileName = Profile.FirstName || '';
    if (accountLoading || isEmpty(Profile)) {
        return (
            <SkeletonWrapperWelcomeMsg>
                <Skeleton width={250} height={44} />
                <Skeleton width={350} height={22} />
            </SkeletonWrapperWelcomeMsg>
        );
    }

    return (
        <GridWithPadding
            container
            item
            md={12}
            $isMobile={isMobile}
            $hasWarnings={!!warnings?.length}
        >
            <Box style={welcomeHeader}>
                <Typography variant={'h1'}>{`${t('hello')} ${profileName}`}</Typography>
            </Box>
            <Box width="100%">
                <Typography variant={'h3'}>{t('dashboardgreeting')}</Typography>
            </Box>
        </GridWithPadding>
    );
}
